export const STATIC = 'static';
export const MAIN = 'main';
export const CONTENT = 'content';
